<template>
    <Logos></Logos>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Logos = defineAsyncComponent(() =>
    import("../../components/ITDepartment/Logos.vue")
);

export default {
    name: "Logos_Signatures_Wallpapers", //The name you are in should not equal the name of the component you are importing.
    components: { Logos, AuthLayout },
};
</script>
